import { FETCH_VAS_CONTROL_DATA_REQUEST, FETCH_VAS_CONTROL_DATA_SUCCESS, FETCH_VAS_CONTROL_DATA_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getVasControlDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_VAS_CONTROL_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case FETCH_VAS_CONTROL_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case FETCH_VAS_CONTROL_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getVasControlDataReducer;
